import React, {useState} from 'react';
import {useSelector} from "react-redux";
import LogoITM from "../resources/logo/logo_ITM.png";
import LogoIAM from "../resources/logo/logo_IAM.png";
import LogoSRM from "../resources/logo/logo_SRM.png";
import LogoITMDark from "../resources/logo/logo_ITM_dark.png";
import LogoIAMDark from "../resources/logo/logo_IAM_dark.png";
import LogoSRMDark from "../resources/logo/logo_SRM_dark.png";

// 플랫폼별 로고 매핑 (state.auth.platFrom 기준)
// 흰 글자 로고 — 어두운 배경(로그인 화면)용
const PLATFORM_LOGOS = {
    ITM: LogoITM,
    IAM: LogoIAM,
    ITAM: LogoIAM,
    SRM: LogoSRM,
};

// 검정 글자 로고 — 밝은 배경(사이드바/헤더)용
const MENU_LOGOS = {
    ITM: LogoITMDark,
    IAM: LogoIAMDark,
    ITAM: LogoIAMDark,
    SRM: LogoSRMDark,
};

const SERVER_LOGO = "upload/images/logo/logo.png";
const SERVER_MENU_LOGO = "upload/images/logo/menu_logo.png";

/**
 * variant="login" : logo.png -> 번들 흰 글자 로고
 * variant="menu"  : menu_logo.png -> logo.png -> 번들 검정 글자 로고
 *
 * 파일 존재 여부는 요청을 보내봐야 알 수 있으므로 onError 로 다음 후보로 넘어간다.
 */
function PlatformLogo({className, variant = "login"}) {
    const platFrom = useSelector((state) => state.auth.platFrom);
    const IMG_BASE = import.meta.env.VITE_IMG_BASE;

    const sources = variant === "menu"
        ? [IMG_BASE + SERVER_MENU_LOGO, IMG_BASE + SERVER_LOGO, MENU_LOGOS[platFrom] ?? LogoITMDark]
        : [IMG_BASE + SERVER_LOGO, PLATFORM_LOGOS[platFrom] ?? LogoITM];

    const [step, setStep] = useState(0);

    return (
        <img className={`logo-css ${className ?? ""}`}
             src={sources[step]}
             alt={`SIMMS-${platFrom ?? "ITM"}`}
             // 마지막 후보에서 실패하면 인덱스가 고정되어 리렌더가 없다 (무한 루프 방지)
             onError={() => setStep((s) => Math.min(s + 1, sources.length - 1))} />
    );
}

export default PlatformLogo;
